/**
 * @param {string} playerName
 * @param {'F.Lastname' | 'default'} format
 */
export const formatPlayerName = (playerName, format = 'F.Lastname') => {
  if (format === 'F.Lastname') {
    const [firstName, ...rest] = playerName.split(' ')
    return `${firstName[0]}. ${rest.join(' ')}`
  }

  return playerName
}

export const preparePeriodsWithTitleAsNumber = initialData => {
  if (!initialData?.matchResultsPerPeriod?.perPeriod) {
    return []
  }

  return initialData.matchResultsPerPeriod.perPeriod.map((period, index) => ({
    ...period,
    periodLabel: index <= 3 ? index + 1 : `OT${index - 3}`
  }))
}

export const adaptEuroleagueImageUrl = (imageUrl = '', width = '') => `${imageUrl}?width=${width}&resizeType=fill&format=webp`

/**
 * Formats a date from YYYY-MM-DD to DD/MM/YYYY
 * @param {string} dateString - Date in format YYYY-MM-DD
 * @returns {string} Date in format DD/MM/YYYY or empty string if invalid
 */
export function formatDate(dateString) {
  if (!dateString || typeof dateString !== 'string') {
    return ''
  }

  try {
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return '' // Invalid date

    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()

    return `${day}/${month}/${year}`
  } catch (e) {
    return ''
  }
}

const AVAILABLE_BRANDS = ['mozzart', 'soccer-bet']

export const isWidgetBranded = brand => AVAILABLE_BRANDS.includes(brand)
